// Sign up screen translations for all 11 supported languages

export const signupTranslations = {
  pt: {
    title: "Crie a sua conta",
    description: "Comece com clareza financeira.",
    first_name: "Primeiro nome",
    first_name_placeholder: "João",
    last_name: "Apelido",
    last_name_placeholder: "Silva",
    email: "Email",
    email_placeholder: "nome@empresa.com",
    invite_code: "Código de convite",
    invite_code_placeholder: "Introduza o seu código",
    invite_code_hint: "Precisa de um código de convite válido para se registar.",
    invite_code_cta: "Validar código",
    invite_code_verified: "Código validado. Pode continuar com o registo.",
    invite_code_change: "Alterar código",
    early_access_message: "O MoneyLights encontra-se atualmente em acesso antecipado.",
    early_access_invite: "O acesso é disponibilizado apenas por convite.",
    password: "Palavra-passe",
    password_placeholder: "Crie uma palavra-passe segura",
    confirm_password: "Confirmar palavra-passe",
    confirm_password_placeholder: "Digite novamente a palavra-passe",
    password_requirements_title: "A palavra-passe deve conter:",
    requirement_min_length: "Pelo menos 8 caracteres",
    requirement_uppercase: "Pelo menos uma letra maiúscula",
    requirement_lowercase: "Pelo menos uma letra minúscula",
    requirement_number: "Pelo menos um número",
    passwords_match: "As palavras-passe coincidem",
    passwords_dont_match: "As palavras-passe não coincidem",
    create_account: "Criar conta",
    creating_account: "A criar conta...",
    have_account: "Já tem uma conta?",
    sign_in: "Entrar",
    terms_notice: "Ao criar uma conta, concorda com os nossos",
    terms_link: "Termos de Serviço",
    and: "e",
    privacy_link: "Política de Privacidade",
    error_required_fields: "Por favor preencha todos os campos obrigatórios",
    error_invalid_email: "Por favor introduza um email válido",
    error_password_requirements: "A palavra-passe não cumpre os requisitos",
    error_passwords_dont_match: "As palavras-passe não coincidem",
    error_email_exists: "Este email já está registado",
    error_invite_required: "O código de convite é obrigatório",
    error_invite_invalid: "O código de convite não é válido",
    error_invite_used: "Este código de convite já foi utilizado",
    success_title: "Verifique o seu email",
    success_description: "Enviámos um link de verificação para a sua caixa de entrada",
    success_email_sent: "Email enviado para",
    success_instruction_1: "Clique no link de verificação que enviámos para o seu email para ativar a sua conta.",
    success_instruction_2: "Se não receber o email dentro de alguns minutos, verifique a pasta de spam.",
    success_no_email: "Não recebeu o email?",
    success_resend: "Reenviar",
    back_to_login: "Voltar ao início de sessão",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Precisa de ajuda?"
  },
  en: {
    title: "Create your account",
    description: "Start with financial clarity.",
    first_name: "First name",
    first_name_placeholder: "John",
    last_name: "Last name",
    last_name_placeholder: "Smith",
    email: "Email",
    email_placeholder: "name@company.com",
    invite_code: "Invite code",
    invite_code_placeholder: "Enter your code",
    invite_code_hint: "You need a valid invitation code to register.",
    invite_code_cta: "Validate code",
    invite_code_verified: "Code verified. You can continue with registration.",
    invite_code_change: "Change code",
    early_access_message: "MoneyLights is currently in early access.",
    early_access_invite: "Access is available by invitation only.",
    password: "Password",
    password_placeholder: "Create a strong password",
    confirm_password: "Confirm password",
    confirm_password_placeholder: "Re-enter your password",
    password_requirements_title: "Password must contain:",
    requirement_min_length: "At least 8 characters",
    requirement_uppercase: "At least one uppercase letter",
    requirement_lowercase: "At least one lowercase letter",
    requirement_number: "At least one number",
    passwords_match: "Passwords match",
    passwords_dont_match: "Passwords don't match",
    create_account: "Create account",
    creating_account: "Creating account...",
    have_account: "Already have an account?",
    sign_in: "Sign in",
    terms_notice: "By creating an account, you agree to our",
    terms_link: "Terms of Service",
    and: "and",
    privacy_link: "Privacy Policy",
    error_required_fields: "Please fill in all required fields",
    error_invalid_email: "Please enter a valid email",
    error_password_requirements: "Password doesn't meet requirements",
    error_passwords_dont_match: "Passwords don't match",
    error_email_exists: "This email is already registered",
    error_invite_required: "Invite code is required",
    error_invite_invalid: "Invite code is not valid",
    error_invite_used: "This invite code has already been used",
    success_title: "Check your email",
    success_description: "We've sent a verification link to your inbox",
    success_email_sent: "Email sent to",
    success_instruction_1: "Click on the verification link we sent to your email to activate your account.",
    success_instruction_2: "If you don't receive the email within a few minutes, check your spam folder.",
    success_no_email: "Didn't receive the email?",
    success_resend: "Resend",
    back_to_login: "Back to sign in",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Need help?"
  },
  es: {
    title: "Crea tu cuenta",
    description: "Empieza con claridad financiera.",
    first_name: "Nombre",
    first_name_placeholder: "Juan",
    last_name: "Apellidos",
    last_name_placeholder: "García",
    email: "Correo electrónico",
    email_placeholder: "nombre@empresa.com",
    invite_code: "Código de invitación",
    invite_code_placeholder: "Introduce tu código",
    invite_code_hint: "Necesitas un código de invitación válido para registrarte.",
    invite_code_cta: "Validar código",
    invite_code_verified: "Código validado. Puedes continuar con el registro.",
    invite_code_change: "Cambiar código",
    early_access_message: "MoneyLights se encuentra actualmente en acceso anticipado.",
    early_access_invite: "El acceso está disponible solo por invitación.",
    password: "Contraseña",
    password_placeholder: "Crea una contraseña segura",
    confirm_password: "Confirmar contraseña",
    confirm_password_placeholder: "Vuelve a introducir tu contraseña",
    password_requirements_title: "La contraseña debe contener:",
    requirement_min_length: "Al menos 8 caracteres",
    requirement_uppercase: "Al menos una letra mayúscula",
    requirement_lowercase: "Al menos una letra minúscula",
    requirement_number: "Al menos un número",
    passwords_match: "Las contraseñas coinciden",
    passwords_dont_match: "Las contraseñas no coinciden",
    create_account: "Crear cuenta",
    creating_account: "Creando cuenta...",
    have_account: "¿Ya tienes una cuenta?",
    sign_in: "Iniciar sesión",
    terms_notice: "Al crear una cuenta, aceptas nuestros",
    terms_link: "Términos de Servicio",
    and: "y",
    privacy_link: "Política de Privacidad",
    error_required_fields: "Por favor completa todos los campos obligatorios",
    error_invalid_email: "Por favor introduce un email válido",
    error_password_requirements: "La contraseña no cumple los requisitos",
    error_passwords_dont_match: "Las contraseñas no coinciden",
    error_email_exists: "Este email ya está registrado",
    error_invite_required: "El código de invitación es obligatorio",
    error_invite_invalid: "El código de invitación no es válido",
    error_invite_used: "Este código de invitación ya fue usado",
    success_title: "Revisa tu correo electrónico",
    success_description: "Hemos enviado un enlace de verificación a tu bandeja de entrada",
    success_email_sent: "Correo enviado a",
    success_instruction_1: "Haz clic en el enlace de verificación que enviamos a tu correo para activar tu cuenta.",
    success_instruction_2: "Si no recibes el correo en unos minutos, revisa tu carpeta de spam.",
    success_no_email: "¿No recibiste el correo?",
    success_resend: "Reenviar",
    back_to_login: "Volver al inicio de sesión",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "¿Necesitas ayuda?"
  },
  fr: {
    title: "Créez votre compte",
    description: "Commencez avec la clarté financière.",
    first_name: "Prénom",
    first_name_placeholder: "Jean",
    last_name: "Nom",
    last_name_placeholder: "Dupont",
    email: "Email",
    email_placeholder: "nom@entreprise.com",
    invite_code: "Code d'invitation",
    invite_code_placeholder: "Entrez votre code",
    invite_code_hint: "Vous avez besoin d'un code d'invitation valide pour vous inscrire.",
    invite_code_cta: "Valider le code",
    invite_code_verified: "Code validé. Vous pouvez continuer l'inscription.",
    invite_code_change: "Changer de code",
    early_access_message: "MoneyLights est actuellement en accès anticipé.",
    early_access_invite: "L'accès est disponible uniquement sur invitation.",
    password: "Mot de passe",
    password_placeholder: "Créez un mot de passe fort",
    confirm_password: "Confirmer le mot de passe",
    confirm_password_placeholder: "Resaisissez votre mot de passe",
    password_requirements_title: "Le mot de passe doit contenir:",
    requirement_min_length: "Au moins 8 caractères",
    requirement_uppercase: "Au moins une lettre majuscule",
    requirement_lowercase: "Au moins une lettre minuscule",
    requirement_number: "Au moins un chiffre",
    passwords_match: "Les mots de passe correspondent",
    passwords_dont_match: "Les mots de passe ne correspondent pas",
    create_account: "Créer un compte",
    creating_account: "Création du compte...",
    have_account: "Vous avez déjà un compte?",
    sign_in: "Se connecter",
    terms_notice: "En créant un compte, vous acceptez nos",
    terms_link: "Conditions d'Utilisation",
    and: "et",
    privacy_link: "Politique de Confidentialité",
    error_required_fields: "Veuillez remplir tous les champs obligatoires",
    error_invalid_email: "Veuillez entrer un email valide",
    error_password_requirements: "Le mot de passe ne respecte pas les exigences",
    error_passwords_dont_match: "Les mots de passe ne correspondent pas",
    error_email_exists: "Cet email est déjà enregistré",
    error_invite_required: "Le code d'invitation est requis",
    error_invite_invalid: "Le code d'invitation n'est pas valide",
    error_invite_used: "Ce code d'invitation a déjà été utilisé",
    success_title: "Vérifiez votre email",
    success_description: "Nous avons envoyé un lien de vérification dans votre boîte de réception",
    success_email_sent: "Email envoyé à",
    success_instruction_1: "Cliquez sur le lien de vérification que nous avons envoyé à votre email pour activer votre compte.",
    success_instruction_2: "Si vous ne recevez pas l'email dans quelques minutes, vérifiez votre dossier spam.",
    success_no_email: "Vous n'avez pas reçu l'email?",
    success_resend: "Renvoyer",
    back_to_login: "Retour à la connexion",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Besoin d'aide?"
  },
  de: {
    title: "Erstellen Sie Ihr Konto",
    description: "Starten Sie mit finanzieller Klarheit.",
    first_name: "Vorname",
    first_name_placeholder: "Anna",
    last_name: "Nachname",
    last_name_placeholder: "Müller",
    email: "E-Mail",
    email_placeholder: "name@unternehmen.com",
    invite_code: "Einladungscode",
    invite_code_placeholder: "Code eingeben",
    invite_code_hint: "Sie benötigen einen gültigen Einladungscode zur Registrierung.",
    invite_code_cta: "Code prüfen",
    invite_code_verified: "Code bestätigt. Sie können mit der Registrierung fortfahren.",
    invite_code_change: "Code ändern",
    early_access_message: "MoneyLights befindet sich derzeit im Frühzugang.",
    early_access_invite: "Der Zugang ist nur auf Einladung verfügbar.",
    password: "Passwort",
    password_placeholder: "Erstellen Sie ein starkes Passwort",
    confirm_password: "Passwort bestätigen",
    confirm_password_placeholder: "Geben Sie Ihr Passwort erneut ein",
    password_requirements_title: "Das Passwort muss enthalten:",
    requirement_min_length: "Mindestens 8 Zeichen",
    requirement_uppercase: "Mindestens einen Großbuchstaben",
    requirement_lowercase: "Mindestens einen Kleinbuchstaben",
    requirement_number: "Mindestens eine Zahl",
    passwords_match: "Passwörter stimmen überein",
    passwords_dont_match: "Passwörter stimmen nicht überein",
    create_account: "Konto erstellen",
    creating_account: "Konto wird erstellt...",
    have_account: "Haben Sie bereits ein Konto?",
    sign_in: "Anmelden",
    terms_notice: "Mit der Erstellung eines Kontos stimmen Sie unseren",
    terms_link: "Nutzungsbedingungen",
    and: "und",
    privacy_link: "Datenschutzrichtlinien",
    error_required_fields: "Bitte füllen Sie alle erforderlichen Felder aus",
    error_invalid_email: "Bitte geben Sie eine gültige E-Mail ein",
    error_password_requirements: "Passwort erfüllt nicht die Anforderungen",
    error_passwords_dont_match: "Passwörter stimmen nicht überein",
    error_email_exists: "Diese E-Mail ist bereits registriert",
    error_invite_required: "Einladungscode ist erforderlich",
    error_invite_invalid: "Einladungscode ist ungültig",
    error_invite_used: "Dieser Einladungscode wurde bereits verwendet",
    success_title: "Überprüfen Sie Ihre E-Mail",
    success_description: "Wir haben einen Bestätigungslink an Ihren Posteingang gesendet",
    success_email_sent: "E-Mail gesendet an",
    success_instruction_1: "Klicken Sie auf den Bestätigungslink, den wir an Ihre E-Mail gesendet haben, um Ihr Konto zu aktivieren.",
    success_instruction_2: "Wenn Sie die E-Mail nicht innerhalb weniger Minuten erhalten, überprüfen Sie Ihren Spam-Ordner.",
    success_no_email: "E-Mail nicht erhalten?",
    success_resend: "Erneut senden",
    back_to_login: "Zurück zur Anmeldung",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Brauchen Sie Hilfe?"
  },
  it: {
    title: "Crea il tuo account",
    description: "Inizia con chiarezza finanziaria.",
    first_name: "Nome",
    first_name_placeholder: "Marco",
    last_name: "Cognome",
    last_name_placeholder: "Rossi",
    email: "Email",
    email_placeholder: "nome@azienda.com",
    invite_code: "Codice di invito",
    invite_code_placeholder: "Inserisci il tuo codice",
    invite_code_hint: "Hai bisogno di un codice di invito valido per registrarti.",
    invite_code_cta: "Verifica codice",
    invite_code_verified: "Codice verificato. Puoi continuare con la registrazione.",
    invite_code_change: "Cambia codice",
    early_access_message: "MoneyLights è attualmente in accesso anticipato.",
    early_access_invite: "L'accesso è disponibile solo su invito.",
    password: "Password",
    password_placeholder: "Crea una password sicura",
    confirm_password: "Conferma password",
    confirm_password_placeholder: "Reinserisci la tua password",
    password_requirements_title: "La password deve contenere:",
    requirement_min_length: "Almeno 8 caratteri",
    requirement_uppercase: "Almeno una lettera maiuscola",
    requirement_lowercase: "Almeno una lettera minuscola",
    requirement_number: "Almeno un numero",
    passwords_match: "Le password corrispondono",
    passwords_dont_match: "Le password non corrispondono",
    create_account: "Crea account",
    creating_account: "Creazione account...",
    have_account: "Hai già un account?",
    sign_in: "Accedi",
    terms_notice: "Creando un account, accetti i nostri",
    terms_link: "Termini di Servizio",
    and: "e",
    privacy_link: "Informativa sulla Privacy",
    error_required_fields: "Si prega di compilare tutti i campi obbligatori",
    error_invalid_email: "Si prega di inserire un'email valida",
    error_password_requirements: "La password non soddisfa i requisiti",
    error_passwords_dont_match: "Le password non corrispondono",
    error_email_exists: "Questa email è già registrata",
    error_invite_required: "Il codice di invito è obbligatorio",
    error_invite_invalid: "Il codice di invito non è valido",
    error_invite_used: "Questo codice di invito è già stato utilizzato",
    success_title: "Controlla la tua email",
    success_description: "Abbiamo inviato un link di verifica alla tua casella di posta",
    success_email_sent: "Email inviata a",
    success_instruction_1: "Clicca sul link di verifica che abbiamo inviato alla tua email per attivare il tuo account.",
    success_instruction_2: "Se non ricevi l'email entro pochi minuti, controlla la cartella spam.",
    success_no_email: "Non hai ricevuto l'email?",
    success_resend: "Invia di nuovo",
    back_to_login: "Torna al login",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Hai bisogno di aiuto?"
  },
  nl: {
    title: "Maak uw account aan",
    description: "Begin met financiële helderheid.",
    first_name: "Voornaam",
    first_name_placeholder: "Jan",
    last_name: "Achternaam",
    last_name_placeholder: "De Vries",
    email: "E-mail",
    email_placeholder: "naam@bedrijf.com",
    invite_code: "Uitnodigingscode",
    invite_code_placeholder: "Voer uw code in",
    invite_code_hint: "Je hebt een geldige uitnodigingscode nodig om je te registreren.",
    invite_code_cta: "Code controleren",
    invite_code_verified: "Code bevestigd. Je kunt verdergaan met registreren.",
    invite_code_change: "Code wijzigen",
    early_access_message: "MoneyLights is momenteel in vroege toegang.",
    early_access_invite: "Toegang is alleen beschikbaar op uitnodiging.",
    password: "Wachtwoord",
    password_placeholder: "Maak een sterk wachtwoord",
    confirm_password: "Bevestig wachtwoord",
    confirm_password_placeholder: "Voer uw wachtwoord opnieuw in",
    password_requirements_title: "Wachtwoord moet bevatten:",
    requirement_min_length: "Minimaal 8 tekens",
    requirement_uppercase: "Minimaal één hoofdletter",
    requirement_lowercase: "Minimaal één kleine letter",
    requirement_number: "Minimaal één cijfer",
    passwords_match: "Wachtwoorden komen overeen",
    passwords_dont_match: "Wachtwoorden komen niet overeen",
    create_account: "Account aanmaken",
    creating_account: "Account aanmaken...",
    have_account: "Heb je al een account?",
    sign_in: "Inloggen",
    terms_notice: "Door een account aan te maken, ga je akkoord met onze",
    terms_link: "Servicevoorwaarden",
    and: "en",
    privacy_link: "Privacybeleid",
    error_required_fields: "Vul alle verplichte velden in",
    error_invalid_email: "Voer een geldig e-mailadres in",
    error_password_requirements: "Wachtwoord voldoet niet aan de vereisten",
    error_passwords_dont_match: "Wachtwoorden komen niet overeen",
    error_email_exists: "Deze e-mail is al geregistreerd",
    error_invite_required: "Uitnodigingscode is verplicht",
    error_invite_invalid: "Uitnodigingscode is ongeldig",
    error_invite_used: "Deze uitnodigingscode is al gebruikt",
    success_title: "Controleer uw e-mail",
    success_description: "We hebben een verificatielink naar uw inbox gestuurd",
    success_email_sent: "E-mail verzonden naar",
    success_instruction_1: "Klik op de verificatielink die we naar uw e-mail hebben gestuurd om uw account te activeren.",
    success_instruction_2: "Als u de e-mail niet binnen enkele minuten ontvangt, controleer dan uw spam-map.",
    success_no_email: "E-mail niet ontvangen?",
    success_resend: "Opnieuw verzenden",
    back_to_login: "Terug naar inloggen",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Hulp nodig?"
  },
  da: {
    title: "Opret din konto",
    description: "Start med finansiel klarhed.",
    first_name: "Fornavn",
    first_name_placeholder: "Lars",
    last_name: "Efternavn",
    last_name_placeholder: "Nielsen",
    email: "E-mail",
    email_placeholder: "navn@virksomhed.com",
    invite_code: "Invitationskode",
    invite_code_placeholder: "Indtast din kode",
    invite_code_hint: "Du skal bruge en gyldig invitationskode for at registrere dig.",
    invite_code_cta: "Bekræft kode",
    invite_code_verified: "Kode bekræftet. Du kan fortsætte med registreringen.",
    invite_code_change: "Skift kode",
    early_access_message: "MoneyLights er i øjeblikket i tidlig adgang.",
    early_access_invite: "Adgang er kun tilgængelig via invitation.",
    password: "Adgangskode",
    password_placeholder: "Opret en stærk adgangskode",
    confirm_password: "Bekræft adgangskode",
    confirm_password_placeholder: "Indtast din adgangskode igen",
    password_requirements_title: "Adgangskoden skal indeholde:",
    requirement_min_length: "Mindst 8 tegn",
    requirement_uppercase: "Mindst ét stort bogstav",
    requirement_lowercase: "Mindst ét lille bogstav",
    requirement_number: "Mindst ét tal",
    passwords_match: "Adgangskoderne matcher",
    passwords_dont_match: "Adgangskoderne matcher ikke",
    create_account: "Opret konto",
    creating_account: "Opretter konto...",
    have_account: "Har du allerede en konto?",
    sign_in: "Log ind",
    terms_notice: "Ved at oprette en konto accepterer du vores",
    terms_link: "Servicevilkår",
    and: "og",
    privacy_link: "Fortrolighedspolitik",
    error_required_fields: "Udfyld venligst alle obligatoriske felter",
    error_invalid_email: "Indtast venligst en gyldig e-mail",
    error_password_requirements: "Adgangskoden opfylder ikke kravene",
    error_passwords_dont_match: "Adgangskoderne matcher ikke",
    error_email_exists: "Denne e-mail er allerede registreret",
    error_invite_required: "Invitationskode er påkrævet",
    error_invite_invalid: "Invitationskoden er ugyldig",
    error_invite_used: "Denne invitationskode er allerede brugt",
    success_title: "Tjek din e-mail",
    success_description: "Vi har sendt et verificeringslink til din indbakke",
    success_email_sent: "E-mail sendt til",
    success_instruction_1: "Klik på verificeringslinket, som vi har sendt til din e-mail for at aktivere din konto.",
    success_instruction_2: "Hvis du ikke modtager e-mailen inden for få minutter, skal du tjekke din spam-mappe.",
    success_no_email: "Modtog du ikke e-mailen?",
    success_resend: "Send igen",
    back_to_login: "Tilbage til login",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Brug for hjælp?"
  },
  sv: {
    title: "Skapa ditt konto",
    description: "Börja med ekonomisk klarhet.",
    first_name: "Förnamn",
    first_name_placeholder: "Anna",
    last_name: "Efternamn",
    last_name_placeholder: "Karlsson",
    email: "E-post",
    email_placeholder: "namn@företag.com",
    invite_code: "Inbjudningskod",
    invite_code_placeholder: "Ange din kod",
    invite_code_hint: "Du behöver en giltig inbjudningskod för att registrera dig.",
    invite_code_cta: "Verifiera kod",
    invite_code_verified: "Koden är verifierad. Du kan fortsätta registreringen.",
    invite_code_change: "Ändra kod",
    early_access_message: "MoneyLights är för närvarande i tidig åtkomst.",
    early_access_invite: "Åtkomst är tillgänglig endast via inbjudan.",
    password: "Lösenord",
    password_placeholder: "Skapa ett starkt lösenord",
    confirm_password: "Bekräfta lösenord",
    confirm_password_placeholder: "Ange ditt lösenord igen",
    password_requirements_title: "Lösenordet måste innehålla:",
    requirement_min_length: "Minst 8 tecken",
    requirement_uppercase: "Minst en stor bokstav",
    requirement_lowercase: "Minst en liten bokstav",
    requirement_number: "Minst en siffra",
    passwords_match: "Lösenorden matchar",
    passwords_dont_match: "Lösenorden matchar inte",
    create_account: "Skapa konto",
    creating_account: "Skapar konto...",
    have_account: "Har du redan ett konto?",
    sign_in: "Logga in",
    terms_notice: "Genom att skapa ett konto godkänner du våra",
    terms_link: "Användarvillkor",
    and: "och",
    privacy_link: "Integritetspolicy",
    error_required_fields: "Vänligen fyll i alla obligatoriska fält",
    error_invalid_email: "Vänligen ange en giltig e-post",
    error_password_requirements: "Lösenordet uppfyller inte kraven",
    error_passwords_dont_match: "Lösenorden matchar inte",
    error_email_exists: "Denna e-post är redan registrerad",
    error_invite_required: "Inbjudningskod krävs",
    error_invite_invalid: "Inbjudningskoden är ogiltig",
    error_invite_used: "Denna inbjudningskod har redan använts",
    success_title: "Kontrollera din e-post",
    success_description: "Vi har skickat en verifieringslänk till din inkorg",
    success_email_sent: "E-post skickad till",
    success_instruction_1: "Klicka på verifieringslänken som vi skickade till din e-post för att aktivera ditt konto.",
    success_instruction_2: "Om du inte får e-postmeddelandet inom några minuter, kontrollera din skräppostmapp.",
    success_no_email: "Fick du inte e-postmeddelandet?",
    success_resend: "Skicka igen",
    back_to_login: "Tillbaka till inloggning",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Behöver du hjälp?"
  },
  fi: {
    title: "Luo tilisi",
    description: "Aloita taloudellisella selkeydellä.",
    first_name: "Etunimi",
    first_name_placeholder: "Matti",
    last_name: "Sukunimi",
    last_name_placeholder: "Virtanen",
    email: "Sähköposti",
    email_placeholder: "nimi@yritys.com",
    invite_code: "Kutsukoodi",
    invite_code_placeholder: "Syötä koodisi",
    invite_code_hint: "Tarvitset voimassa olevan kutsukoodin rekisteröityäksesi.",
    invite_code_cta: "Vahvista koodi",
    invite_code_verified: "Koodi vahvistettu. Voit jatkaa rekisteröitymistä.",
    invite_code_change: "Vaihda koodi",
    early_access_message: "MoneyLights on tällä hetkellä varhaisessa käytössä.",
    early_access_invite: "Pääsy on saatavilla vain kutsulla.",
    password: "Salasana",
    password_placeholder: "Luo vahva salasana",
    confirm_password: "Vahvista salasana",
    confirm_password_placeholder: "Syötä salasanasi uudelleen",
    password_requirements_title: "Salasanan tulee sisältää:",
    requirement_min_length: "Vähintään 8 merkkiä",
    requirement_uppercase: "Vähintään yksi iso kirjain",
    requirement_lowercase: "Vähintään yksi pieni kirjain",
    requirement_number: "Vähintään yksi numero",
    passwords_match: "Salasanat täsmäävät",
    passwords_dont_match: "Salasanat eivät täsmää",
    create_account: "Luo tili",
    creating_account: "Luodaan tiliä...",
    have_account: "Onko sinulla jo tili?",
    sign_in: "Kirjaudu sisään",
    terms_notice: "Luomalla tilin hyväksyt meidän",
    terms_link: "Käyttöehdot",
    and: "ja",
    privacy_link: "Tietosuojakäytännön",
    error_required_fields: "Täytä kaikki pakolliset kentät",
    error_invalid_email: "Anna kelvollinen sähköpostiosoite",
    error_password_requirements: "Salasana ei täytä vaatimuksia",
    error_passwords_dont_match: "Salasanat eivät täsmää",
    error_email_exists: "Tämä sähköpostiosoite on jo rekisteröity",
    error_invite_required: "Kutsukoodi vaaditaan",
    error_invite_invalid: "Kutsukoodi ei ole voimassa",
    error_invite_used: "Tämä kutsukoodi on jo käytetty",
    success_title: "Tarkista sähköpostisi",
    success_description: "Olemme lähettäneet vahvistuslinkin postilaatikkoosi",
    success_email_sent: "Sähköposti lähetetty osoitteeseen",
    success_instruction_1: "Napsauta vahvistuslinkkiä, jonka lähetimme sähköpostiisi aktivoidaksesi tilisi.",
    success_instruction_2: "Jos et saa sähköpostia muutaman minuutin sisällä, tarkista roskapostikansiosi.",
    success_no_email: "Etkö saanut sähköpostia?",
    success_resend: "Lähetä uudelleen",
    back_to_login: "Takaisin kirjautumiseen",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Tarvitsetko apua?"
  },
  et: {
    title: "Loo oma konto",
    description: "Alusta finantsilise selgusega.",
    first_name: "Eesnimi",
    first_name_placeholder: "Karl",
    last_name: "Perekonnanimi",
    last_name_placeholder: "Tamm",
    email: "E-post",
    email_placeholder: "nimi@ettevõte.com",
    invite_code: "Kutsukood",
    invite_code_placeholder: "Sisesta oma kood",
    invite_code_hint: "Registreerumiseks on vaja kehtivat kutsukoodi.",
    invite_code_cta: "Kinnita kood",
    invite_code_verified: "Kood kinnitatud. Saad registreerimist jätkata.",
    invite_code_change: "Muuda koodi",
    early_access_message: "MoneyLights on hetkel varajases ligipääsus.",
    early_access_invite: "Ligipääs on saadaval ainult kutse alusel.",
    password: "Parool",
    password_placeholder: "Loo tugev parool",
    confirm_password: "Kinnita parool",
    confirm_password_placeholder: "Sisesta oma parool uuesti",
    password_requirements_title: "Parool peab sisaldama:",
    requirement_min_length: "Vähemalt 8 tähemärki",
    requirement_uppercase: "Vähemalt üks suur täht",
    requirement_lowercase: "Vähemalt üks väike täht",
    requirement_number: "Vähemalt üks number",
    passwords_match: "Paroolid klapivad",
    passwords_dont_match: "Paroolid ei klapi",
    create_account: "Loo konto",
    creating_account: "Konto loomine...",
    have_account: "Kas sul on juba konto?",
    sign_in: "Logi sisse",
    terms_notice: "Konto loomisega nõustud meie",
    terms_link: "Teenuse tingimustega",
    and: "ja",
    privacy_link: "Privaatsuspoliitikaga",
    error_required_fields: "Palun täida kõik kohustuslikud väljad",
    error_invalid_email: "Palun sisesta kehtiv e-post",
    error_password_requirements: "Parool ei vasta nõuetele",
    error_passwords_dont_match: "Paroolid ei klapi",
    error_email_exists: "See e-post on juba registreeritud",
    error_invite_required: "Kutsukood on kohustuslik",
    error_invite_invalid: "Kutsukood ei ole kehtiv",
    error_invite_used: "See kutsukood on juba kasutatud",
    success_title: "Kontrolli oma e-posti",
    success_description: "Saatsime kinnituslingi sinu postkasti",
    success_email_sent: "E-kiri saadetud aadressile",
    success_instruction_1: "Klõpsa kinnituslingil, mille saatsime sinu e-posti, et aktiveerida oma konto.",
    success_instruction_2: "Kui sa ei saa e-kirja mõne minuti jooksul, kontrolli oma rämpsposti kausta.",
    success_no_email: "Ei saanud e-kirja?",
    success_resend: "Saada uuesti",
    back_to_login: "Tagasi sisselogimisse",
    footer_text: "© 2026 Borlantrix OÜ. MoneyLights® is a registered trademark.",
    need_help: "Kas vajad abi?"
  }
};
